import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as uiReducer } from 'redux-fui';
import { createResponsiveStateReducer } from 'redux-responsive';
import auth from './auth';
import locations from './locations';
import messages from './messages';
import search from './search';
import consents from './consents';
import styleguide from './styleguide';
import seasonTicketForm from './forms/seasonTickets';
import { reducer as form } from '../components/Decorators/form';
import features from './features';

export default combineReducers({
  routing: routerReducer,
  auth,
  features,
  locations,
  messages,
  search,
  styleguide,
  consents,
  browser: createResponsiveStateReducer({
    extraSmall: 640,
    small: 860,
    medium: 1024,
    large: 1220,
    extraLarge: 1440
  }),
  ui: uiReducer,
  seasonTicketForm,
  form
});
